<div class="order-markers-common-view">
  <div class="row justify-content-around">
    <div class="col">
      <div class="item flex align-items-center justify-content-end">
        <ng-container *ngFor="let item of items">
          <app-component-resolver *ngIf="item.config.isComponent" class="item__description ms-3" [data]="item.value"
            [config]="item.config.componentConfig">
          </app-component-resolver>
          <div *ngIf="!item.config.isComponent" class="item__description ms-3">
            <button mat-raised-button [color]="item.config.color" (click)="click(item.config)">
              {{item.config.nameBtn}}
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>